import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AnonymousContentPage } from 'shared.root/components/anonymous-content-page/anonymous-content-page';

@Component({
  selector: 'nc-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  standalone: false,
})

export class TermsAndConditionsComponent extends AnonymousContentPage implements OnInit {
  termAndConditionText: Observable<string>;
  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTermAndConditionText();
  };

  getTermAndConditionText(): void {
    this.termAndConditionText = this.activatedRoute.data
      .pipe(
        take(1),
        map((data) => data.result),
      );
  }

}
